/**
 * The sorted column is never collapsed — one rule, every list.
 *
 * A list ordered by a value it does not show is a list you cannot read: the rows
 * are in an order whose key is invisible, so the ordering is unfalsifiable. The
 * inbox did exactly this — opening the record pane hid four columns to buy
 * width, and one of them was SLA, which is what "Soonest due first" sorts by.
 *
 * So: **a column the list is currently sorted by stays on screen.** It holds in
 * all four places a column can go away —
 *
 *   · the record pane's automatic suppression (`PANE_SUPPRESSED`, InboxScreen)
 *   · a filter pinning a column to one value (`pinnedColumns`, RecordListShell)
 *   · the Columns picker, on every grid (`DataTable`, the inbox's `ColumnPicker`)
 *   · the column header's own "Hide column" (`DataTable`)
 *
 * — and in the last two the control is *disabled with the reason on it* rather
 * than missing, because an affordance that says why it is unavailable is a
 * decision and an absent one is a bug.
 *
 * Sorting by a hidden column is still allowed from the toolbar's Sort menu; it
 * simply brings the column back, which is the same promise read from the other
 * end.
 *
 * This module is a leaf on purpose: `components/ui/DataTable` and `lib/
 * constants` both read it, and neither may import the other.
 */

/** The one sentence every refused hide-control prints. */
export const SORT_LOCK_REASON = 'The list is sorted by this column';

/** The one word the Columns picker puts on a locked row. */
export const SORT_LOCK_TAG = 'sorted';
